import { ConfigurationState } from "./interfaces";
import { tryParseUrl } from "../../utils/commonUtils";

const tryParseVisualizerApiUrl = (input : string | undefined) => {
    const parsed = tryParseUrl(input);
    if (!parsed){
        throw "Cannot parse Visualizer API url from: " + input;
    }

    return parsed;
}

// Use env files in local development and window._env_ in production.
// Unset env vars are empty strings, not undefined, so ?? would never fall through to window._env_.
const firstNonEmpty = (...values : (string | undefined)[]) =>
    values.find(value => typeof value === "string" && value.trim() !== "");

const pickUrl = (buildTimeValue : string | undefined, runtimeValue : string | undefined) =>
    tryParseUrl(firstNonEmpty(buildTimeValue, runtimeValue));

const initialConfigurationState: ConfigurationState = {
    visualizerApiUrl:   tryParseVisualizerApiUrl(firstNonEmpty(import.meta.env.VITE_VISUALIZER_API_URL, window._env_?.VITE_VISUALIZER_API_URL)),
    bimVaultApiUrl:     pickUrl(import.meta.env.VITE_BIMVAULT_API_URL,  window._env_?.VITE_BIMVAULT_API_URL),
    threeDeeApiUrl:     pickUrl(import.meta.env.VITE_THREE_DEE_API_URL, window._env_?.VITE_THREE_DEE_API_URL),
    coreApiUrl:         pickUrl(import.meta.env.VITE_CORE_API_URL,      window._env_?.VITE_CORE_API_URL),
    configurationLoaded: false,
    preferredLanguage: "en"
};

export default initialConfigurationState;
